export function getRelativeImagePath(imagePath: string) {
  const relativePath = imagePath?.replace(/^.*\/\/[^/]+/, "");
  if (!relativePath) {
    return "";
  }

  if (process.env.NODE_ENV === "development" || (process.browser && window.location.hostname === "localhost")) {
    return `https://integ.partsavatar.ca${relativePath}`;
  }
  return relativePath;
}
